// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"F_cq","breadcrumbs__link":"F_cr","breadcrumbs__link__active":"F_cs","breadcrumbs__span":"F_ct"};